const RECAPTCHA_SITE_KEY = "6Lfi2ncbAAAAAM5HdzMrDNcSkFpmh0ARSsU81BRx";

// Modale z formularzami na karcie produktu chronione antyspamem: „Zgłoś błąd w opisie" i „Zapytaj o produkt".
const PROTECTED_MODALS = ['#descriptionErrorModal', '#productQuestion'];

// Czas otwarcia formularza — do analizy czasu (bot wysyła natychmiast).
const bindModal = (selector) => {
    const modal = $(selector);
    if (modal.length === 0) {
        return;
    }
    let formOpenedAt = Date.now();

    modal.on('shown.bs.modal', function () {
        formOpenedAt = Date.now();
    });

    modal.on('click', '[type="submit"]', function (e) {
        const form = $(this).closest('form');
        if (form.length === 0) {
            return;
        }
        e.preventDefault();
        form.find('input[name="elapsedTime"]').val(Date.now() - formOpenedAt);

        if (typeof grecaptcha === 'undefined') {
            form.trigger('submit');
            return;
        }
        grecaptcha.ready(function () {
            grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' }).then(function (token) {
                form.find('input[name="g-recaptcha-response"]').val(token);
                form.trigger('submit');
            });
        });
    });
};

const init = () => {
    PROTECTED_MODALS.forEach(bindModal);
};

export {
    init,
}
